import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";

interface Props {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { me, isLoading } = useAuthStore();
  if (isLoading) {
    return <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  }
  if (!me) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
